export enum SettingsTab {
  Main = 'main',
  Layout = 'layout',
  Design = 'design',
  Sections = 'sections',
  Support = 'support',
}

export enum SettingsSection {
  Header = 'header',
  About = 'about',
  PostList = 'post-list',
  TextStyle = 'text-style',
  ButtonStyle = 'button-style',
  DividersStyle = 'dividers-style',
  BackgroundAndBordersStyle = 'background-and-borders-style',
}

export enum SettingsSectionState {
  Default = 'default',
  Empty = 'empty',
}

export interface SettingsEvent {
  tabChanged: SettingsTab;
  sectionChanged: SettingsSection;
  sectionStateChanged: SettingsSectionState;
}
